import React, { useState } from 'react';
import setOffer from '../../api/Admin/setOffer';
import styles from './AdminPanel.module.css';

const DealyGoOffer = () => {
    const [form, setForm] = useState({
        id: '',
        title: '',
        description: ''
    });

    // 🔧 Met à jour le state à chaque changement d'input
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    // 🚀 Appel à l'API pour mettre à jour l'offre
    const handleUpdate = async () => {
        if (!form.id || !form.title) {
            alert("L'id et le titre sont requis !");
            return;
        }

        const result = await setOffer({
            id: form.id,
            index: 1, // index fixé à 1
            title: form.title,
            description: form.description
        });

        if (result.ok) {
            alert("✅ Offre mise à jour avec succès !");
        } else {
            alert(`❌ Erreur (${result.status}) : ${result.data?.msg || result.error}`);
        }
    };

    return (
        <div className={styles.box}>
            <input
                type='number'
                name='id'
                placeholder='Id du commerçant'
                value={form.id}
                onChange={handleChange}
            />
            <input
                type="text"
                name="title"
                placeholder="Titre de l'offre"
                value={form.title}
                onChange={handleChange}
            />
            <textarea
                name="description"
                placeholder="Description de l'offre"
                value={form.description}
                onChange={handleChange}
            />
            <button onClick={handleUpdate}>Mettre à jour</button>
        </div>
    );
};

export default DealyGoOffer;
